<template>
  <div>
    <h3 class="mb-3 text-gray-800">{{ $t("Técnicos participantes") }}</h3>

    <div v-if="mensagemAlerta" class="alert alert-warning" role="alert">
      {{ mensagemAlerta }}
    </div>

    <div class="table-responsive">
      <table class="table table-sm table-bordered table-hover bg-white">
        <thead class="thead-light">
          <tr>
            <th>Nome</th>
            <th>Profissão</th>
            <th class="text-center confirmar-coluna">Confirmar presença</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="tecnico in tecnicos" :key="tecnico.id">
            <td class="align-middle font-weight-bold">{{ tecnico.nome || tecnico.name }}</td>
            <td class="align-middle">{{ tecnico.profissao || "Não informado" }}</td>
            <td class="align-middle text-center">
              <b-form-radio-group
                v-model="marcacoes[tecnico.id]"
                :name="'presenca-tecnico-' + tecnico.id"
                @change="mensagemAlerta = ''"
              >
                <b-form-radio :value="true">Sim</b-form-radio>
                <b-form-radio :value="false">Não</b-form-radio>
              </b-form-radio-group>
            </td>
          </tr>
          <tr v-if="!tecnicos.length">
            <td colspan="3" class="text-center text-muted py-4">
              Nenhum técnico participante foi vinculado à atividade.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="tecnicos.length" class="row align-items-center mt-3">
      <div class="col-md-6">
        <b-form-select v-model="marcacaoEmLote" @change="marcarTodos">
          <option value="">Confirmar</option>
          <option value="sim">Todos com sim</option>
          <option value="nao">Todos com não</option>
        </b-form-select>
      </div>
      <div class="col-md-6 text-right">
        <b-button variant="success" :disabled="salvando" @click="salvar">
          <i class="mdi mdi-content-save"></i> Salvar
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ListaTecnicosParticipantes",
  props: {
    atividade: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      marcacoes: {},
      marcacaoEmLote: "",
      mensagemAlerta: "",
      salvando: false,
    };
  },
  computed: {
    tecnicos() {
      return this.atividade.participantes_array || [];
    },
    presentes() {
      return this.tecnicos
        .filter((tecnico) => this.marcacoes[tecnico.id] === true)
        .map((tecnico) => tecnico.id);
    },
    ausentes() {
      return this.tecnicos
        .filter((tecnico) => this.marcacoes[tecnico.id] === false)
        .map((tecnico) => tecnico.id);
    },
  },
  watch: {
    atividade: {
      immediate: true,
      handler() {
        this.inicializarMarcacoes();
      },
    },
  },
  methods: {
    normalizarIds(lista) {
      return (lista || []).map((item) => String(item && item.id ? item.id : item));
    },
    inicializarMarcacoes() {
      const presentes = this.normalizarIds(this.atividade.participantes_presentes);
      const ausentes = this.normalizarIds(this.atividade.participantes_ausentes);
      const marcacoes = {};

      this.tecnicos.forEach((tecnico) => {
        const id = String(tecnico.id);
        marcacoes[tecnico.id] = presentes.includes(id)
          ? true
          : ausentes.includes(id)
          ? false
          : null;
      });
      this.marcacoes = marcacoes;
    },
    marcarTodos(valor) {
      if (!valor) return;
      const presente = valor === "sim";
      const marcacoes = {};
      this.tecnicos.forEach((tecnico) => {
        marcacoes[tecnico.id] = presente;
      });
      this.marcacoes = marcacoes;
      this.mensagemAlerta = "";
    },
    salvar() {
      if (this.presentes.length + this.ausentes.length !== this.tecnicos.length) {
        this.mensagemAlerta = "Existe(m) técnico(s) sem marcação de participação";
        return;
      }

      this.salvando = true;
      axios
        .post("api/dashboard/update/participantes/atividades", {
          id: this.atividade.id,
          presenca: this.presentes,
          participantes_ausentes: this.ausentes,
        })
        .then((response) => {
          this.$emit("atualizado", {
            presentes: this.presentes,
            ausentes: this.ausentes,
          });
          this.$snack.success({ button: false, text: response.data.data.message });
        })
        .catch((error) => {
          const mensagem =
            error.response && error.response.data
              ? error.response.data.message
              : "Erro ao salvar a lista de presença.";
          this.$snack.danger({ button: false, text: mensagem });
        })
        .finally(() => {
          this.salvando = false;
        });
    },
  },
};
</script>

<style scoped>
.confirmar-coluna {
  min-width: 220px;
}
</style>
